import type { IReaction } from '../../types/interfaces/reaction';

/**
 * Compact like counts: 0–999 as-is, 1k–999k, 1m–999m (larger values shown as 999m).
 */
export function formatLikeCount(n: number): string {
  const v = Math.max(0, Math.floor(Number.isFinite(n) ? n : 0));
  if (v < 1000) {
    return String(v);
  }
  if (v < 1_000_000) {
    const k = Math.floor(v / 1000);
    return `${Math.min(k, 999)}k`;
  }
  if (v < 1_000_000_000) {
    const m = Math.floor(v / 1_000_000);
    return `${Math.min(m, 999)}m`;
  }
  return '999m';
}

/**
 * Reconciles cached `reactions.length` with optimistic `userReaction` after toggle before refetch.
 */
export function getDisplayReactionCount(
  reactions: IReaction[] | undefined,
  userId: string | undefined,
  userReaction: boolean | null,
): number {
  const base = reactions?.length ?? 0;
  if (!userId || userReaction === null) {
    return base;
  }
  const apiLiked = !!reactions?.some((r) => r.userId === userId);
  if (userReaction === apiLiked) {
    return base;
  }
  return userReaction ? base + 1 : base - 1;
}
